export const SET_INITIAL_REQUIRED_DATA = "SET_INITIAL_REQUIRED_DATA";
export const SET_RESET_REGISTRATION_STATE = "SET_RESET_REGISTRATION_STATE";
export const IS_REGISTRATION_SUCCESS = "IS_REGISTRATION_SUCCESS";
export const DISCOM_OPTIONS = "DISCOM_OPTIONS";
export const STATE_OPTIONS = "STATE_OPTIONS";
export const STATE_CON_OPTIONS = "STATE_CON_OPTIONS";
export const DISCOM_CON_OPTIONS = "DISCOM_CON_OPTIONS";
